var exports = {
  "kL": "xa15a2ab7--30c421--container",
  "wm": "xa15a2ab7--30c421--logo",
  "DD": "xa15a2ab7--30c421--title",
  "h5": "xa15a2ab7--30c421--status",
  "Ou": "xa15a2ab7--30c421--status-title",
  "Ix": "xa15a2ab7--30c421--facts",
  "fK": "xa15a2ab7--30c421--fact",
  "nf": "xa15a2ab7--30c421--link",
};

module.exports = exports;
